import styled, { keyframes } from 'styled-components';

// Utils
import Icon from '../Icon';
import { Link } from 'react-router-dom';
import { Button } from '../Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0);
  }
  
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Search = styled.form`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 670px;
  margin-left: 3vw;
  border: 0;
  background: #fff;
  border-radius: 4px;
  height: 40px;

  @media (max-width: 1200px) {
    margin-left: 3vw;
    max-width: 500px;
    flex-basis: 293px;
  }

  @media (max-width: 820px) {
    max-width: 306px;
    margin-left: 2vw;
  }

  @media (max-width: 767px) {
    order: 1;
    width: 100%;
    flex-grow: 1;
    max-width: none;
    flex-basis: 100%;
    margin: 8px 0 0;
  }

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg .header & {
      margin-left: 10px;
    }
  }

  .simplebar-track.simplebar-vertical {
    right: 5px;
  }
`;

export const Input = styled.input.attrs(() => ({
  type: 'search',
}))`
  outline: none;
  width: 100%;
  flex-grow: 1;
  flex-shrink: 0;
  height: 36px;
  border: none;
  padding: 10px 15px 10px;

  &::placeholder {
    color: var(--grey50);
  }

  @media (max-width: 820px) {
    padding: 10px 10px 10px 15px;
  }
`;

export const SubmitBtn = styled(Button)`
  width: 92px;
  cursor: pointer;
  margin: 0;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  transition: var(--transition-btn);

  &:focus {
    outline: none;
  }
`;

export const MenuSubmit = styled.button`
  width: 100%;
  height: 36px;
  background: var(--theme-palette-brand-bg);
  border: none;
  color: var(--white);
  cursor: pointer;
  margin: 0;
  border-radius: 4px;
  transition: var(--transition-btn);
  display: none;

  @media (max-width: 767px) and (orientation: portrait) {
    display: block;
  }

  &:focus {
    outline: none;
  }
`;

export const Clear = styled.button`
  position: absolute;
  right: 104px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background: var(--aluminium60);
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 0;
  transition: var(--transition);

  &:hover {
    background: var(--aluminium100);
  }

  &.empty-field {
    opacity: 0;
  }

  &:focus {
    outline: none;
  }

  .icon_clear {
    fill: var(--white);
    position: absolute;
    top: 1px;
    left: 1px;
    right: 0;
    bottom: 0;
    margin: auto;
    font-size: 7px;
  }
`;

export const SearchLoader = styled.div`
  position: absolute;
  right: 104px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  z-index: 10;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .ant-spin {
    line-height: 1;
  }
`;

export const NoResults = styled.div`
  padding: 15px;
  text-align: center;
  color: var(--carbone80);
`;

export const Dropdown = styled.div`
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  border: 1px solid #e1e7ed;
  box-sizing: border-box;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  left: 0;
  right: 0;
  z-index: 3;
  background: #fff;
  width: ${({ modular }) => (modular ? `calc(100% - 143px)` : '100%')};

  @media (max-width: 767px) and (orientation: portrait) {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    height: calc(100 * var(--full-vh, 1vh));

    .dropdown-spinner {
      min-height: calc(100 * var(--full-vh, 1vh));
    }

    ${NoResults} {
      min-height: calc(100 * var(--full-vh, 1vh));
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Inner = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  background: var(--white);
  position: relative;
  z-index: 0;
  margin-bottom: 0;
  border-radius: 4px;
  border: 2px solid var(--aluminium20);
`;

export const PreviewItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 7px 7px 7px 8px;
  cursor: pointer;
  text-decoration: none;
  transition: var(--transition);

  &:hover {
    background: var(--aluminium10);
    border-radius: 4px;
  }
`;

export const Item = styled(Link)`
  display: flex;
  justify-content: space-between;
  padding: 9px 10px 9px 8px;
  cursor: pointer;
  color: #1e1e1e;
  text-decoration: none;
  transition: var(--transition);

  &:hover {
    background: var(--aluminium10);
    border-radius: 4px;
  }
`;

export const GoodsData = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const Photo = styled.div`
  margin-right: 16px;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border: 1px solid var(--aluminium60);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--white);

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const Img = styled.img`
  max-width: 40px;
  max-height: 40px;
  height: auto;
  width: auto;
`;

export const Content = styled.div`
  min-width: 0;
  overflow: hidden;
`;

export const Title = styled.div`
  display: inline;
  font-family: var(--primary-font), sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--carbone100);
  margin-right: 9px;
`;

export const Descr = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const Tags = styled.div`
  position: relative;
  max-width: 165px;
  padding-right: 26px;
  color: var(--carbone60);
  margin-bottom: 2px;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:not(:last-child) {
    &:after {
      content: '';
      height: 16px;
      width: 1px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 13px;
      margin: auto;
      background: var(--aluminium60);
    }
  }

  .icon {
    width: 12px;
    margin-right: 7px;
    flex-grow: 1;
    flex-shrink: 0;
  }
`;

export const TagsInner = styled.div`
  display: flex;
  align-items: center;
`;

export const Txt = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 165px;
  white-space: nowrap;
`;

export const Price = styled.div`
  flex-shrink: 0;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  color: var(--green120);
  text-align: right;
  padding-left: 12px;

  @media (max-width: 820px) {
    white-space: nowrap;
  }
`;

export const Badge = styled.span`
  font-family: var(--primary-font), sans-serif;
  font-size: 10px;
  color: #922b13;
  background: rgba(252, 121, 91, 0.15);
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
`;

export const Header = styled.div``;

export const Show = styled.div`
  color: var(--theme-palette-brand-color);
  text-decoration: none;
  padding: 4px 7px 0;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    color: var(--theme-palette-brand-bg-hover);
  }
`;

export const Group = styled.div``;

export const GroupName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--aluminium100);
  margin: 0 7px;
`;

export const Items = styled.div``;

export const CustomItems = styled.div`
  padding: 6px 0;

  ${GoodsData} {
    width: auto;
  }
`;

export const Div = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  margin: 15px 7px;
  background: var(--aluminium35);

  &:last-child:not(:first-child) {
    display: none;
  }
`;

export const Results = styled.div`
  padding: 8px 16px 8px 8px;

  &:before,
  &:after {
    content: '';
    height: 90px;
    left: 0;
    right: 0;
    position: absolute;
    display: none;
  }

  &:before {
    top: 0;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 15%,
      rgba(255, 255, 255, 1) 20%
    );
    z-index: 1;
  }

  &:after {
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 5%,
      rgba(255, 255, 255, 1) 20%
    );
    z-index: 91;
  }

  @media (max-width: 767px) and (orientation: portrait) {
    -webkit-overflow-scrolling: touch;
    height: 95vh;
    height: calc(95 * var(--full-vh, 1vh));
    overflow-y: auto;
    padding: 70px 12px 60px;

    &:before,
    &:after {
      display: block;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 1;
  display: none;
  pointer-events: none;
`;

export const FooterBtn = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  padding: 20px;
  background: #fff;
  display: none;

  @media (max-width: 767px) and (orientation: portrait) {
    display: block;
  }
`;

export const Close = styled.button`
  display: none;
  border: none;
  background: none;
  padding: 0;
  z-index: 4;
  color: var(--carbone70);

  @media (max-width: 767px) and (orientation: portrait) {
    display: block;
  }
`;

export const InputIcon = styled(Icon)`
  display: none;
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  transition: all 0.5s;
`;

export const ShowTrigger = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border-radius: 6px;
  font-weight: 600;
  font-family: var(--primary-font), sans-serif;
  font-size: 13px;
  line-height: 1.38em;
  padding: 7px 10px;
  color: var(--carbone100);
  white-space: nowrap;
  transition: var(--transition);
  border: 1px solid var(--aluminium75);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 2px 7px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  margin-left: 20px;

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg & {
      margin-left: 8px;
    }
  }

  .icon {
    color: var(--carbone100);
    font-size: 15px;
  }

  &:hover {
    border-color: var(--carbone80);
  }

  .search-modal-is-open & {
    display: none;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

export const ExtWrapper = styled(Search)`
  &.is-focus {
    ${Inner} {
      border: 2px solid var(--theme-palette-brand-color);
    }

    ${SubmitBtn} {
      background: var(--theme-palette-brand-bg);
      color: var(--white);
    }
  }

  &.is-active {
    @media (max-width: 767px) and (orientation: portrait) {
      margin-top: 0;
      position: inherit;

      ${Overlay} {
        display: block;
      }

      ${SubmitBtn} {
        display: none;
      }

      ${Clear} {
        right: 12px;
      }

      ${SearchLoader} {
        right: 12px;
      }

      ${Inner} {
        margin-left: auto;
        z-index: 5;
        width: calc(100% - 34px);
        border: 2px solid var(--theme-palette-brand-color);
        border-radius: 4px;
        height: 40px;
      }
    }
  }

  .search-modal-is-open & {
    &.is-folded {
      display: flex;
    }

    &.is-top-offset {
      position: static;
    }
  }

  @media (min-width: 768px) {
    &.is-folded {
      display: none;
    }

    &.is-top-offset {
      position: absolute;
      left: 0;
      top: 68px;
      width: 100%;
      margin-left: 0;
      right: 0;
      max-width: none;
      z-index: 2;
      animation: ${fadeIn} 0.2s;
    }
  }
`;
